import BnSnDhanStocksPage from "./bnsndhanstockspage";

export default function BnDhanStocks() {
  return (
    <BnSnDhanStocksPage
      desk="bn"
      title="DHAN BANKNIFTY STOCKS MARKET REACTION"
      gridTitle="Live Dhan BankNifty Weightage Grid"
      activeTab="banknifty"
    />
  );
}
